import PropTypes from "prop-types";
import classnames from "classnames";

import "./skeleton.scss";

const Skeleton = ({
  children,
  className,
  loaded,
  count,
  theme,
  gap,
  settings,
  animate,
  size,
}) => {
  if (loaded) return children;

  return (
    <div
      className={classnames("skeleton", className, {
        [`skeleton--${theme}`]: theme,
        [`skeleton--${size}`]: size,
        "skeleton--animate": animate,
      })}
      style={{ gap }}
    >
      {Array(count)
        .fill()
        .map((_, index) => (
          <div className="skeleton__item" key={index} style={settings} />
        ))}
    </div>
  );
};

Skeleton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  loaded: PropTypes.bool,
  count: PropTypes.number,
  theme: PropTypes.oneOf(["default", "primary", "danger"]),
  gap: PropTypes.number,
  settings: PropTypes.object,
  animate: PropTypes.bool,
  size: PropTypes.oneOf(["xsmall", "small", "medium", "large"]),
};

Skeleton.defaultProps = {
  animate: false,
  gap: 16,
  count: 1,
  theme: "default",
  size: "medium",
};

export default Skeleton;
